import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search, Bell, StickyNote } from "lucide-react";

export const CustomerFilters = ({
  searchQuery,
  setSearchQuery,
  categories,
  filterCategory,
  setFilterCategory,
  filterMaintenance,
  setFilterMaintenance,
  filterNotes,
  setFilterNotes,
  filterReminders,
  setFilterReminders,
  reminderCount,
}) => (
  <div className="flex flex-wrap gap-4 items-center">
    <div className="relative flex-1 min-w-64">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      <Input
        placeholder="Suche nach Firma, Stadt oder E-Mail..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-10"
        data-testid="customer-search-input"
      />
    </div>
    <Select value={filterCategory} onValueChange={setFilterCategory}>
      <SelectTrigger className="w-40" data-testid="filter-category">
        <SelectValue placeholder="Alle Kategorien" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Alle Kategorien</SelectItem>
        {categories.map((cat) => (
          <SelectItem key={cat} value={cat}>{cat}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    <Select value={filterMaintenance} onValueChange={setFilterMaintenance}>
      <SelectTrigger className="w-44" data-testid="filter-maintenance">
        <SelectValue placeholder="Wartungsvertrag" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Alle</SelectItem>
        <SelectItem value="yes">Mit Wartungsvertrag</SelectItem>
        <SelectItem value="no">Ohne Wartungsvertrag</SelectItem>
      </SelectContent>
    </Select>
    <Select value={filterNotes} onValueChange={setFilterNotes}>
      <SelectTrigger className="w-40" data-testid="filter-notes">
        <StickyNote className="w-4 h-4 mr-2 text-muted-foreground" />
        <SelectValue placeholder="Notizen" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Alle Notizen</SelectItem>
        <SelectItem value="yes">Mit Notizen</SelectItem>
        <SelectItem value="no">Ohne Notizen</SelectItem>
      </SelectContent>
    </Select>
    <Button
      variant={filterReminders ? "default" : "outline"}
      onClick={() => setFilterReminders(!filterReminders)}
      className="gap-2"
      data-testid="filter-reminders"
    >
      <Bell className={`w-4 h-4 ${filterReminders ? "text-primary-foreground" : "text-amber-500"}`} />
      <span className="hidden sm:inline">Mit Erinnerungen</span>
      {reminderCount > 0 && (
        <Badge variant={filterReminders ? "secondary" : "destructive"} className="ml-1">
          {reminderCount}
        </Badge>
      )}
    </Button>
  </div>
);
